import React, { useState } from 'react';
import styled from 'styled-components';
import Select from 'react-select';
import {
  DISH_TYPE_TAGS,
  CATEGORY_INGREDIENTS,
  TEMPLATE_PARAMETERS_TAG,
  VIDEO_TAGS,
} from '../../../constants/appConstants';

const categoryGroupOptions = [
  {
    id: DISH_TYPE_TAGS,
    name: 'Вид блюда',
  },
  {
    id: CATEGORY_INGREDIENTS,
    name: 'Категория продуктов',
  },
  {
    id: TEMPLATE_PARAMETERS_TAG,
    name: 'Параметры шаблона',
  },
  {
    id: VIDEO_TAGS,
    name: 'Видео тренировок/саморазвития',
  },
];

const TagPopup = ({ isCreatingMode, editingTagObj, onCreateTag, onEditTag, cancel }) => {
  const [tagName, setTagName] = useState(editingTagObj ? editingTagObj.name : '');
  const [categoryId, setCategoryId] = useState(CATEGORY_INGREDIENTS);

  const onCreate = () => {
    onCreateTag(tagName, categoryId);
    cancel();
  };

  const onEdit = () => {
    onEditTag(editingTagObj.tag_id, tagName);
    cancel();
  };

  return (
    <FillPopupSpace>
      <Popup>
        {isCreatingMode ? (
          <Title>Создание тега</Title>
        ) : (
          <Title>
            Редактировать тег
            <OldName>{editingTagObj.name}</OldName>
          </Title>
        )}
        {isCreatingMode && (
          <Select
            placeholder="Выберите группу тега..."
            options={categoryGroupOptions}
            labelKey="name"
            valueKey="id"
            value={categoryId}
            onChange={(valueObj) => setCategoryId(valueObj.id)}
            clearable={false}
          />
        )}
        <Input
          value={tagName}
          onChange={(e) => setTagName(e.target.value)}
          placeholder="Ввведите название тега..."
          clearable={false}
        />
        <ButtonsWrapper>
          <CancelButton onClick={cancel}>Отмена</CancelButton>
          <Button onClick={isCreatingMode ? onCreate : onEdit} disabled={!tagName.trim().length}>
            {isCreatingMode ? 'Создать' : 'Редактировать'}
          </Button>
        </ButtonsWrapper>
      </Popup>
    </FillPopupSpace>
  );
};

export default TagPopup;

const FillPopupSpace = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 1;
  z-index: 4;
`;

const Popup = styled.div`
  width: 400px;
  padding: 30px 15px;
  text-align: center;
  background: #fff;
  border-radius: 5px;
  z-index: 100;
  border: 1px solid #000;
  @media (max-width: 768px) {
    width: 80%;
  }
`;

const Title = styled.h3`
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0px;
`;

const Input = styled.input`
  margin: 20px 0px;
  width: 100%;
  height: 40px;
  font-size: 18px;
  padding: 5px 15px;
  box-sizing: border-box;
  border: 1px solid #000;
  border-radius: 2px;
`;

const OldName = styled.p`
  color: #af480c;
  margin: 10px 0;
`;

const ButtonsWrapper = styled.div`
  width: 85%;
  margin: 0 auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
`;

const Button = styled.button`
  width: 150px;
  height: 40px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
  text-align: center;
  font-size: 16px;
  background: ${(props) => (props.disabled ? '#999999' : '#157aac')};
  color: #fff;
  border: none;
  border-radius: 5px;
  &:hover {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    background: ${(props) => (props.disabled ? '#999999' : '#17ade3')};
  }
  @media (max-width: 450px) {
    margin: 0 10px;
  }
`;

const CancelButton = Button.extend`
  background: ${(props) => (props.disabled ? '#999999' : '#db2828')};
  &:hover {
    background: ${(props) => (props.disabled ? '#999999' : '#d01919')};
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Common/TagPopup/TagPopup.jsx